import constants from '@/helpers/constants';
import { Logger } from '@/services/Logger';
import { TripUpdateReq } from '@/services/signalr/MessageTypes/TripUpdateReq';
import { Signalr } from '@/services/signalr/Signalr';
import { IStatusTime } from '~/api/IStatusTime';

export interface UpdateTripTimestampsParams {
  tripId: string;
  statusTimes: IStatusTime[];
}

export async function updateTripTimestamps(
  signalr: Signalr,
  logger: Logger,
  params: UpdateTripTimestampsParams,
): Promise<void> {
  try {
    await signalr.invoke(TripUpdateReq, {
      id: params.tripId,
      statusTimes: params.statusTimes,
      contextKey: constants.UI.CONTEXTS.EDIT_TIMESTAMP,
    });
  }
  catch (error) {
    logger.captureException(error as Error, { tags: { tripManager: 'updateTripTimestamps' } });
  }
}
